<template>
  <div :class="className">
    <a
      :class="titleClassName"
      :href="href"
      :title="title || ''"
      @click="handleClick"
    >
      {{ title }}
    </a>
    <slot />
  </div>
</template>

<script>
const name = 'ten-anchor-link';

export default {
  name,
  inject: ['anchor'],
  props: {
    /**
     * 锚点链接
     */
    href: {
      type: String,
    },
    /**
     * 文字内容
     */
    title: {
      type: String,
    },
  },
  computed: {
    active() {
      return this.anchor.activeLink === this.href;
    },
    className() {
      return [
        'ten-anchor-link',
        {
          'ten-anchor-link--active': this.active,
        },
      ];
    },
    titleClassName() {
      return [
        'ten-anchor-link-title',
        {
          'ten-anchor-link-title--active': this.active,
        },
      ];
    },
  },
  watch: {
    href(val, oldVal) {
      this.$nextTick(() => {
        this.anchor.removeLink(oldVal);
        this.anchor.appendLink(val);
      });
    },
  },
  mounted() {
    this.anchor.appendLink(this.href);
  },
  beforeDestroy() {
    this.anchor.removeLink(this.href);
  },
  methods: {
    handleClick(e) {
      this.anchor.scrollTo(this.href);
      this.anchor.$emit('link:click', e, this);
    },
  },
};
</script>
